import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-mapping-country-code',
  templateUrl: './mapping-country-code.component.html',
  styleUrls: ['./mapping-country-code.component.scss']
})
export class MappingCountryCodeComponent {
  @Input() form: FormGroup;
  @Input() editMode: boolean;
}
